import { Col, Form, Row } from "antd";
import i18n from "i18next";
import { type FC } from "react";

import { ActionBar } from "../../../../../components/ActionBar/ActionBar";
import { ResetButton } from "../../../../../components/FeatureButtons/ResetButton";
import { SearchButton } from "../../../../../components/FeatureButtons/SearchButton";
import { SelectDynamic } from "../../../../../components/Form/formComponents";
import { FormComponent } from "../../../../../components/Form/types/types";

export type SiteSelectorProps = {
    searchCallback: () => void;
    resetCallback: () => void;
    siteIdInput: string;
    setSiteIdInput: (value: string) => void;
};

export const SiteSelector: FC<SiteSelectorProps> = ({ searchCallback, resetCallback, siteIdInput, setSiteIdInput }) => {
    const fieldConfig = {
        urlToFetchOptions: "configurations/org-unit-site-id",
        optionDisplayPropName: "key",
        optionValuePropName: "value",
        name: "siteId",
        component: FormComponent.SELECT_DYNAMIC,
        translationKeys: { label: "contractCreateForm.site" },
    };

    return (
        <>
            <Row>
                <Col span={16}>
                    <Form.Item label={i18n.t("site.column.siteId")}>
                        <SelectDynamic name="" label="" fieldConfig={fieldConfig} onChange={(e) => setSiteIdInput(e)} value={siteIdInput} />
                    </Form.Item>
                </Col>
            </Row>
            <ActionBar className="left">
                <SearchButton isDisabled={false} callback={searchCallback} />
                <ResetButton isDisabled={false} callback={resetCallback} />
            </ActionBar>
        </>
    );
};
